<template>
    <cms-block v-bind="$props" @block-selected="selectBlock" :style="blockStyle">
        <cms-block-renderer v-for="(child, index) in block.children" :key="child.id" @block-selected="selectBlock" :block="child" :parent="block"
                            :block-selection="blockSelection" :editable="editable" :active="index === 0"/>
    </cms-block>
</template>

<script>
import CmsBlock from "@/components/editor/rendering/blocks/cms-block.vue";
import CmsBlockRenderer from "@components/editor/rendering/blocks/cms-block-renderer.vue";

// cms-block-faq-list #hot-reload-debug
export default {
    name: `cms-block-faq-list`,
    components: {CmsBlockRenderer, CmsBlock},
    extends: CmsBlock,
    computed: {
        blockStyle() {
            let style = {
                "--list-item-spacing": this.block.mediaProxy.spacing
            }
            if (this.block.divider.active) {
                style[`--divider-width`] = this.block.divider.mediaProxy.width;
                style[`--divider-color`] = this.block.divider.mediaProxy.color;
            }
            return style;
        }
    }
}
</script>

<style lang="scss" scoped>
.cms-block-faq-list {
    --list-item-spacing: 10px;

    ::v-deep .cms-block {
        //margin-bottom: var(--list-item-spacing);
        break-inside:avoid;
    }

    .cms-list-item {
        width: 100%;
    }

    ::v-deep > .cms-container {
        display: grid;
        grid-template-columns: repeat(var(--list-item-columns), 1fr);
        grid-gap: var(--list-item-spacing);
    }
}
</style>
